export const WDW_WILL_CALL_CONFIRMATION_TEMPLATE = "wdw_will_call_confirmation";
